import { defineComponent as c, createElementBlock as d, openBlock as a, createElementVNode as o, createBlock as n, unref as t, toDisplayString as m, createVNode as l } from "vue";
import { ScalarColorModeToggle as b } from "@scalar/components";
import { ScalarIconX as p, ScalarIconList as u, ScalarIconMagnifyingGlass as g } from "@scalar/icons";
const h = { class: "t-doc__header mobile-header" }, S = { class: "mobile-header-breadcrumbs" }, _ = { class: "mobile-header-actions" }, w = /* @__PURE__ */ c({
  __name: "DocumentMobileHeader",
  props: {
    label: {},
    showSideBar: { type: Boolean }
  },
  emits: ["showSearch", "toggleSidebar"],
  setup(f, { emit: i }) {
    const r = i;
    return (s, e) => (a(), d("div", h, [
      o("button", {
        class: "icon-button",
        type: "button",
        onClick: e[0] || (e[0] = () => r("toggleSidebar"))
      }, [
        s.showSideBar ? (a(), n(t(p), { key: 0 })) : (a(), n(t(u), { key: 1 }))
      ]),
      o("span", S, m(s.label), 1),
      o("div", _, [
        o("button", {
          class: "icon-button",
          type: "button",
          onClick: e[1] || (e[1] = () => r("showSearch"))
        }, [
          l(t(g))
        ]),
        l(t(b), { class: "mobile-header-darkmode-toggle" })
      ])
    ]));
  }
});
export {
  w as default
};
